// extracted by css-extract-rspack-plugin
export default {"form":"WRre87"};